export const useStyles = () => {
    return {
        container: {
            position: 'relative'
        },
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        icon: {
            fontSize: '2.4rem',
            padding: '0px',
            '&.blue': {
                color: 'secondary.main',
            }
        },
        clean: {
            fontSize: '2rem',
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        hide: {
            visibility: 'hidden',
            display: 'none'
        },
    }
}